import PostMessageEventHandler from '../post_message/post_message_event_handler';
import Document from '../document/models/document';
import { DocumentActions } from '../document/reflux/document_store';
import { formatLocalizedDatetimeToISO8601 } from '../utils/formatting_utils';

const attachDocument = (eventName, eventData) => {
	const actionData = eventData.data;
	const inputDocumentId = parseBPMFieldName(actionData.fieldName);
	const document = parseBPMDocument(actionData.document);

	DocumentActions.attachDocument(inputDocumentId, document);
};

const parseBPMFieldName = (bpmFieldName) => {
	return bpmFieldName.replace(/^\$/, "");
};

const parseBPMDocument = (bpmDocument) => {
	return new Document({
		id: bpmDocument.idDocumento,
		fileUUID: bpmDocument.fileUniqueId,
		fileName: bpmDocument.nomeDocumento,
		createdAt: formatLocalizedDatetimeToISO8601(bpmDocument.dataCriacao),
		author: bpmDocument.autorDocumento,
		version: bpmDocument.versaoDocumento
	});
};

PostMessageEventHandler.subscribe("ATTACH_DOCUMENT", attachDocument);
